export function obtenerIDVisitante () {
  // Verificar si Piwik está definido
  const piwikInterval = setInterval(() => {
    if(typeof Piwik !== 'undefined'){
      setLeadId();
      clearInterval(piwikInterval);
    }
  }, 1000);
}

function setLeadId(){
  if (typeof Piwik !== 'undefined') {
    // Verificar si Piwik.getAsyncTracker está definido
    // eslint-disable-next-line no-undef
    if (typeof Piwik.getAsyncTracker === 'function') {
      // Obtener el tracker asíncrono de Piwik
      // eslint-disable-next-line no-undef
      const tracker = Piwik.getAsyncTracker()

      // Verificar si getVisitorId está definido en el tracker
      if (typeof tracker.getVisitorId === 'function' && Boolean(document.querySelector('#idlead'))) {
        // Obtener el ID del visitante
        const visitorId = tracker.getVisitorId()
        document.querySelector('#idlead').value = visitorId
        if (typeof iframes !== 'undefined') {
          // eslint-disable-next-line no-undef
          iframes.forEach(iframe => {
            let src = iframe.getAttribute('src')
            // Check if src already has params
            const paramsIndex = src.indexOf('?')
            if (paramsIndex !== -1) {
              src += '&dclid=' + visitorId
            } else {
              src += '?dclid=' + visitorId
            }
            iframe.setAttribute('src', src)
          })
        }
      }
    }
  }
}